import { RouterModule, Routes } from '@angular/router';
import { NgModule } from '@angular/core';
import { redirectToOpenProjectGuard, rememberWizardNameGuard } from '@configurator/guards/wizard.guard';
import { WizardStartupService } from '@configurator/wizard-start/wizard-startup.service';
import { OpenProjectComponent } from '@project/components/project/open-project/open-project.component';
import { conjunctionGuard } from '@shared/guard/conjunction.guard';
import { authorizedGuard } from '@user/guards/authorized.guard';
import { RouteNavigationService } from '@services/route-navigation.service';

const routes: Routes = [
  { path: 'configurator', loadChildren: () => import('./configurator/configurator.module').then((m) => m.ConfiguratorModule) },
  { path: 'admintool', loadChildren: () => import('./admintool/admintool.module').then((m) => m.AdminToolModule) },
  {
    path: 'open-project',
    redirectTo: 'configurator/open-project',
  },
  {
    path: 'wizard/:wizardName',
    component: OpenProjectComponent,
    canActivate: [conjunctionGuard],
    data: {
      guards: [
        rememberWizardNameGuard,
        authorizedGuard,
        redirectToOpenProjectGuard,
      ]
    }
  },
  { path: 'profile', loadChildren: () => import('./login/login.module').then((m) => m.LoginModule) },
  { path: '**', redirectTo: 'configurator', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
  providers: [
    RouteNavigationService,
    WizardStartupService,
    ...WizardStartupService.provideModels(),
  ],
})
export class AppRoutingModule {}
